module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pure-u-g"
  }, [_c('div', {
    staticClass: "pure-u-md-1-5 pure-u-lg-1-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-md-3-5 pure-u-lg-1-2"
  }, [_c('div', {
    staticClass: "padding-30-reactive content box"
  }, [_c('div', {
    staticClass: "pure-u-sm-1-5 pure-u-lg-1-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "pure-u-sm-3-5 pure-u-lg-1-2"
  }, [_c('form', {
    staticClass: "pure-u-1 pure-form pure-form-stacked",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_c('h3', {
    staticClass: "pure-u-1 margin-bottom-10 responsive"
  }, [_vm._v("First, let’s see if we can deliver to you")]), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 subtext margin-left-10"
  }, [_vm._v("Already a Tavour member? "), _c('a', {
    staticClass: "link",
    on: {
      "click": function($event) {
        return _vm.$emit('login')
      }
    }
  }, [_vm._v("Login")])]), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 spacing-30"
  }), _vm._v(" "), _c('label', {
    staticClass: "pure-u-1",
    attrs: {
      "for": "zipCode"
    }
  }, [_vm._v("What's your delivery zip code?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zipCode),
      expression: "zipCode"
    }],
    staticClass: "pure-input-1 pure-u-1 ",
    attrs: {
      "id": "zipCode",
      "type": "tel"
    },
    domProps: {
      "value": (_vm.zipCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.zipCode = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.showError) ? _c('div', {
    staticClass: "text-red pure-u-1"
  }, [_vm._v(_vm._s(_vm.errorMsg))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "spacing-30 pure-u-1"
  }), _vm._v(" "), _c('label', {
    staticClass: "pure-u-1"
  }, [_vm._v("Are you at least 21 years old?")]), _vm._v(" "), _c('YesNo', {
    staticClass: "pure-u-1",
    model: {
      value: (_vm.isOfAge),
      callback: function($$v) {
        _vm.isOfAge = $$v
      },
      expression: "isOfAge"
    }
  }), _vm._v(" "), (!_vm.isOfAge) ? _c('div', {
    staticClass: "text-red pure-u-1"
  }, [_vm._v("Must be at least 21 years old to sign up!")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "spacing-30 pure-u-1"
  }), _vm._v(" "), (_vm.isBusy) ? _c('Loading') : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "pure-u-1 pure-button pure-button-primary block",
    attrs: {
      "type": "submit",
      "disabled": !_vm.isOfAge
    }
  }, [_vm._v("Next")])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ebab04be!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/start/ZipAndAge.vue
// module id = 416
// module chunks = 1